import { api } from '@/lib/api'

export async function fetchOperationsSettings() {
  const { data } = await api.get('/masters/operations-settings')
  return data.data.operations
}

/**
 * @param {Record<string, unknown>} payload
 */
export async function updateOperationsSettings(payload) {
  const { data } = await api.put('/masters/operations-settings', payload)
  return data.data.operations
}
